<template>
    <b-card class="shadow">
        <div class="row">
            <div class="col-12">
                <div
                    class="d-flex align-items-center justify-content-between mb-4"
                >
                    <h5 class="mb-0 text-gray-800">
                        {{ $t("Todas Unidades") }}
                    </h5>
                    <b-button-group>
                        <b-button
                            variant="outline-dark"
                            :class="viewFilterReport === true ? 'active' : ''"
                            @click="viewFilters"
                        >
                            <i class="fas fa-filter"></i>
                            {{ $t("Filtros") }}
                        </b-button>
                        <b-button variant="outline-dark" @click="print()">
                            <i class="fas fa-print"></i>
                        </b-button>
                        <b-button
                            variant="outline-dark"
                            @click="exportar()"
                            :title="$t('Exportar')"
                            v-b-tooltip.hover
                        >
                            <i class="fas fa-file-excel"></i>
                        </b-button>
                    </b-button-group>
                </div>
            </div>

            <div class="col-12" v-if="viewFilterReport">
                <!-- Filtros -->
                <form @submit.prevent="getAnalytics" ref="addItem">
                    <div class="row">
                        <form-calendar
                            v-model="data_inicio"
                            grid="3"
                            label="Data inicial"
                            :max-date="dataNow"
                        />

                        <form-calendar
                            v-model="data_fim"
                            grid="3"
                            label="Data final"
                            :required="verificaDataInicial"
                            :min-date="data_inicio"
                            :max-date="dataNow"
                        />
                        <form-select
                            v-model="filtroStatus"
                            grid="6"
                            label="Status"
                            :itens="status"
                            :loading="loadingStatus"
                            :disabled="loadingStatus"
                            multiple
                        />

                        <form-select
                            v-model="filtroTipos"
                            label="Filtrar por Tipo"
                            grid="12"
                            :itens="tipos"
                            :disabled="loadingSearchTipos"
                            :loading="loadingSearchTipos"
                            :multiple="true"
                        />

                        <div class="col-md-12">
                            <label><b>Pesquisar</b></label>
                            <div class="input-group">
                                <b-input
                                    placeholder="No campo acima você pode pesquisar por: No campo acima você pode pesquisar por: Nome, E-mail ou Telefone."
                                    class="form-control search-input"
                                    type="text"
                                    v-model="search"
                                    aria-describedby="input-search"
                                    @keydown.enter.prevent="getAnalytics"
                                />
                            </div>
                            <p class="small text-muted">
                                No campo acima você pode pesquisar por: Nome,
                                E-mail, Telefone.
                            </p>
                        </div>
                    </div>
                    <div class="row pt-4 mb-4 px-0 d-flex justify-content-end">
                        <div class="col-auto px-2 text-right">
                            <button
                                class="btn btn-default"
                                @click.prevent="
                                    limparFiltros(), (viewFilterReport = false)
                                "
                            >
                                <i class="fas fa-times"></i>
                            </button>

                            <button
                                type="button"
                                class="btn btn-secondary"
                                @click.prevent="limparFiltros()"
                            >
                                {{ $t("Limpar Filtros") }}
                            </button>

                            <button
                                class="btn btn-success btn-submit"
                                data-style="zoom-in"
                                type="submit"
                            >
                                <i class="fas fa-chart-bar"></i>
                                {{ $t("Gerar Relatório") }}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
            <loading-report
                :loading="isLoadingMsg"
                mensagem="Por favor aguarde estamos realizando sua solicitação..."
                icone="fa-smile-wink"
            ></loading-report>

            <div class="col-md-12">
                <loading-animation
                    :active.sync="loading"
                    :is-full-page="false"
                    :opacity="1"
                    color="#5895FF"
                />

                <print-content>
                    <template v-slot:datas>
                        <p
                            class="d-flex align-items-center justify-content-between mb-4"
                        >
                            <span
                                >Período selecionado:
                                <b>{{ datas.start }} - {{ datas.end }}</b>
                                <b-link
                                    href="#"
                                    @click.prevent="void 0"
                                    class="mb-2"
                                    variant="info"
                                    v-b-popover.hover.top="
                                        'Através do botão filtros você pode selecionar um intervalo de datas para impressão de seus dados.'
                                    "
                                >
                                    <i class="fas fa-info-circle"></i> </b-link
                            ></span>

                            <span v-if="pagination.total"
                                >Total de Registros <b>{{ pagination.total }}</b
                                >, total por página
                                <b>{{ pagination.perPage }}</b></span
                            >
                        </p>
                    </template>

                    <b-table
                        :fields="[
                            {
                                key: 'nome',
                                label: $t('Detalhes'),
                            },
                            {
                                key: 'nome_tipo_unidade',
                                label: $t('Tipo'),
                            },
                            {
                                key: 'created_at',
                                label: $t('Datas'),
                            },
                            {
                                key: 'status',
                                label: $t('Status'),
                            },
                            {
                                key: 'actions',
                                label: '',
                                class: 'text-right no-print',
                                thStyle: { width: '95px', minWidth: '95px' },
                            },
                        ]"
                        :items="itensList"
                        :responsive="true"
                        striped
                        hover
                        show-empty
                        small
                        outlined
                        stacked="xs"
                        table-class="mb-3"
                    >
                        <template v-slot:cell(nome)="data">
                            <strong
                                class="d-block"
                                v-if="data.item"
                                v-html="
                                    $options.filters.highlight(
                                        data.item.nome,
                                        search
                                    )
                                "
                            ></strong>
                            <small>
                                <span
                                    class="d-block"
                                    v-if="data.item.email"
                                    v-html="
                                        $options.filters.highlight(
                                            data.item.email,
                                            search
                                        )
                                    "
                                ></span>

                                <span
                                    class="d-block"
                                    v-if="data.item.telefone"
                                    v-html="
                                        $options.filters.highlight(
                                            data.item.telefone,
                                            search
                                        )
                                    "
                                ></span>
                                <span
                                    class="d-block"
                                    v-if="data.item.tecnicos.length > 0"
                                >
                                    Equipe SUAS:
                                    <strong
                                        >({{
                                            data.item.tecnicos.length
                                        }})</strong
                                    >
                                </span>
                            </small>
                        </template>

                        <template v-slot:cell(nome_tipo_unidade)="data">
                            {{ data.item.nome_tipo_unidade }}
                        </template>

                        <template v-slot:cell(created_at)="data">
                            <span class="text-muted small d-block">
                                Criado em: {{ data.item.cadastro }}<br />
                                Atualizado em: {{ data.item.atualizacao }}
                            </span>
                        </template>

                        <template v-slot:cell(status)="data">
                            <span v-html="data.item.status_nome"></span>
                        </template>

                        <template v-slot:cell()="data">
                            <b-button
                                :title="$t('Editar Unidade')"
                                :to="'/dashboard/unidades/edit/' + data.item.id"
                                target="_blank"
                                class="px-2 mb-0"
                                size="xs"
                                type="button"
                                v-b-tooltip.hover
                                variant="success"
                            >
                                <i class="mdi mdi-square-edit-outline" />
                            </b-button>
                        </template>
                        <template v-slot:empty="scope">
                            <div class="text-center my-5">
                                <img
                                    :alt="$t('No results')"
                                    class="mb-5"
                                    src="/img/icons/robot.svg"
                                    style="max-height: 165px"
                                />
                                <h3 class="bold">
                                    {{ $t("No records found") }}
                                </h3>
                            </div>
                        </template>
                    </b-table>
                </print-content>

                <div class="row align-items-center">
                    <div class="col-lg-6 col-md-12">
                        <div class="form-group d-inline-flex mb-0">
                            <select
                                class="form-control"
                                style="width: 70px"
                                v-model="perPage"
                                v-on:change="getAnalytics"
                            >
                                <option value="5">5</option>
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                        </div>
                        <div class="d-inline-flex ml-2">
                            <b-pagination
                                :per-page="perPage"
                                :total-rows="pagination.total"
                                @change="changePage"
                                v-model="page"
                            />
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
                        <div class="float-lg-right">
                            {{ $t("Showing page") }}
                            {{ pagination.currentPage }} {{ $t("of") }}
                            {{ pagination.totalPages }}
                            {{ $t("pages in") }}
                            {{ pagination.total }}
                            {{ $t("records") }}
                        </div>
                    </div>
                </div>
                <div class="box-btn-print no-print">
                    <b-button
                        v-if="!loading"
                        :title="$t('Visualizar e Imprimir')"
                        class="py-2"
                        size="sm"
                        type="button"
                        v-b-tooltip.hover
                        variant="primary"
                        @click="print()"
                    >
                        <i class="fas fa-print"></i>
                    </b-button>
                </div>
            </div>
        </div>
    </b-card>
</template>

<script>
export default {
    name: "HomeReportTecnicos",
    data() {
        return {
            loading: true,
            loadingSearchUnidade: true,
            desabledSearchUnidade: true,
            loadingSearchTipos: true,
            loadingStatus: false,
            itensList: [],
            unidades: [],
            page: 1,
            search: "",
            perPage: 10,
            pagination: {
                currentPage: 0,
                perPage: 0,
                total: 0,
                totalPages: 0,
            },
            filtros: {
                unidade: null,
            },
            isLoadingMsg: false,
            filter: false,
            user_id: null,
            tecnico_id: null,
            unidade_id: null,
            role: null,
            loadingStatus: false,
            loadingTipos: false,
            tipos: [],
            status: [],
            datas: [],
            filtroDatas: [],
            filtroStatus: [],
            filtroTipos: [],
        };
    },
    created() {
        this.min = 18;
        this.max = 65;
        this.enableCross = false;
    },

    mounted() {
        this.getAnalytics();
        this.getStatus();
        this.getUnidades();
        this.getTipos();
    },
    methods: {
        filterData(value) {
            return this.$options.filters.formatDateHora(value);
        },
        changePage(page) {
            if (
                page > 0 &&
                page <= this.pagination.totalPages &&
                page !== this.page
            ) {
                this.page = page;
                this.getAnalytics();
            }
        },
        async getAnalytics() {
            this.isLoadingMsg = true;
            this.loading = true;

            this.filtroDatas = [];
            if (this.data_inicio) {
                this.filtroDatas.push(
                    this.$options.filters.formatDateYMD(this.data_inicio)
                );
            }
            if (this.data_fim) {
                this.filtroDatas.push(
                    this.$options.filters.formatDateYMD(this.data_fim)
                );
            }

            await axios
                .get("api/dashboard/report/unidades/home", {
                    params: {
                        page: this.page,
                        search: this.search,
                        perPage: this.perPage,
                        filtroDatas: this.filtroDatas,
                        filtroStatus: this.filtroStatus,
                        filtroTipos: this.filtroTipos,
                    },
                })
                .then((response) => {
                    this.loading = false;

                    this.user_id = this.$store.state.user.id;
                    this.tecnico_id = this.$store.state.user.tecnico.id;
                    this.unidade_id = this.$store.state.unidade;
                    this.role = this.$store.state.user.role;

                    this.datas = response.data.datas;
                    this.itensList = response.data.dados.original.data;
                    this.pagination = response.data.dados.original.pagination;
                    if (
                        this.pagination.totalPages < this.pagination.currentPage
                    ) {
                        this.page = this.pagination.totalPages;
                        this.getAnalytics();
                    } else {
                        this.isLoadingMsg = false;
                        this.loading = false;
                    }
                })
                .catch(() => {
                    this.isLoadingMsg = false;
                    this.loading = false;
                });
        },
        getUnidades() {
            this.loadingSearchUnidade = true;
            this.desabledSearchUnidade = true;
            axios
                .get(`api/dashboard/unidades/get/externas`)
                .then((response) => {
                    this.unidades = response.data;
                })
                .finally(() => {
                    this.loadingSearchUnidade = false;
                    this.desabledSearchUnidade = false;
                });
        },
        getStatus() {
            this.loadingStatus = true;
            axios
                .get(`api/dashboard/status/unidades`)
                .then((response) => {
                    this.status = response.data;
                })
                .finally(() => {
                    this.loadingStatus = false;
                });
        },
        getTipos() {
            this.loadingSearchTipos = true;
            axios
                .get(`api/dashboard/unidade/tipos`)
                .then((response) => {
                    this.tipos = response.data;
                })
                .finally(() => (this.loadingSearchTipos = false));
        },
        exportar() {
            this.isLoadingMsg = true;
            this.loading = true;
            swal.fire({
                title: "Aguarde! O Arquivo está sendo gerado.",
                text: "O tempo para finalizar pode demorar dependendo a quantidade De registros.",
                imageUrl: `${window.urlbase}img/load.gif`,
                showConfirmButton: false,
            });
            axios
                .get("api/dashboard/report/unidades/home", {
                    params: {
                        page: this.page,
                        search: this.search,
                        perPage: this.perPage,
                        filtroDatas: this.filtroDatas,
                        filtroStatus: this.filtroStatus,
                        filtroTipos: this.filtroTipos,
                        export: "ok",
                    },
                })
                .then((response) => {
                    this.isLoadingMsg = false;
                    this.loading = false;

                    swal.fire({
                        title: "Arquivo Pronto para Download!",
                        html: `<a href="${response.data.link}" target="_blank">Clique aqui para baixar</a>`,
                        icon: "success",
                        showConfirmButton: false,
                    });
                })
                .finally(() => {
                    (this.isLoadingMsg = false), (this.loading = false);
                });
        },
        limparFiltros() {
            //   this.filtros = {};
            this.search = "";
            this.data_inicio = "";
            this.data_fim = "";
            this.filtros.data_inicial = "";
            this.filtros.data_final = "";

            this.filtroDatas = [];
            this.filtroStatus = [];
            this.filtroTipos = [];
            this.getAnalytics();
        },
    },
};
</script>
